const GLYPHS = {
  facebook: (
    <path d="M13.4 21v-7.6h2.6l.4-3h-3V8.5c0-.9.3-1.5 1.6-1.5h1.6V4.3c-.3 0-1.2-.1-2.4-.1-2.4 0-4 1.4-4 4.1v2.1H7.6v3h2.6V21Z" />
  ),
  instagram: (
    <>
      <path
        fillRule="evenodd"
        d="M8 3h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5Zm.4 1.8a3.6 3.6 0 0 0-3.6 3.6v7.2a3.6 3.6 0 0 0 3.6 3.6h7.2a3.6 3.6 0 0 0 3.6-3.6V8.4a3.6 3.6 0 0 0-3.6-3.6ZM12 7.4a4.6 4.6 0 1 1 0 9.2 4.6 4.6 0 0 1 0-9.2Zm0 1.7a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8Z"
      />
      <circle cx="16.9" cy="7.1" r="1.1" />
    </>
  ),
};

/** Brand glyph filled with the site's metallic gold gradient. */
export function SocialIcon({ name }) {
  const gradientId = `mjm-social-gold-${name}`;
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill={`url(#${gradientId})`}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2=".35" y2="1">
          <stop offset="0" stopColor="#f4e4b8" />
          <stop offset=".5" stopColor="#c99f58" />
          <stop offset="1" stopColor="#94702f" />
        </linearGradient>
      </defs>
      {GLYPHS[name]}
    </svg>
  );
}
